<template>
  <div class="user-info-wrapper">

      <!-- div>
        <img src="../../assets/images/default-user.png" alt="" />
      </div -->

    <div class="user-info">
      <userToggleMenu @onDeconnexion="handleDeconnexion">
        <div class="user-info-inner">
          <div class="name">{{this.userName}}</div>
          <div class="societe">{{this.societeNom()}}</div>
        </div>
      </userToggleMenu>
    </div>

  </div>
</template>
<script>
import userToggleMenu from '../userMenuComponent/userToggleMenu'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    userToggleMenu
  },
  computed: {
    userName () {
      return `${this.firstName().charAt(0)}. ${this.name()}`
    }
  },
  methods: {
    ...mapActions(['logout']),
    ...mapGetters(['firstName', 'name', 'societeNom']),
    upperCaseFirstChar (string) {
      return `${string.charAt(0).toUpperCase()}${string.slice(1)}`
    },
    handleDeconnexion () {
      this.logout().then(resp => {
        this.$router.push('login')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  color: #fff;

  img {
    border-radius: 50%;
    height: 35px;
    margin-right: 5px;
  }
  .user-info-inner {
    margin-right: 20px;
    height: 35px;
    text-align: left;
    .name {
      font-size: 14px;
      font-family: "Noto Sans";
      font-weight: 400;
      line-height: 19px;
      color: #fff;
    }
    .societe {
      font-size: 10px;
      font-family: "Noto Sans";
      font-weight: 400;
      line-height: 14px;
      text-transform: uppercase;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserInfoHeader.vue